export default __webpack_public_path__ + "static/media/Nav-Statement active.ec522775.svg";